import '@/class-component-hooks.ts'
import Vue from 'vue'
import '@/filters/formatDate'
import '@/filters/formatJourLivraison'
import '@/filters/formatDuree'
import '@/filters/currency'
import '@/filters/poids'
import '@/filters/tva'
import '@/filters/moyenPaiement'
import '@/filters/typeReduction'
import '@/filters/capitalize'
import '@/filters/tel'
import '@/filters/trackset'
import '@/filters/livraison'
import '@/filters/fileIcons'
import VConfirmDialog from './plugins/confirm'
import App from './App.vue'
import VueRouter from './router'
import StoreHelper from './plugins/storeHelper'
import store from './store'
import vuetify from './plugins/vuetify'
import CKEditor from 'ckeditor4-vue' 
//import FlagIcon from 'vue-flag-icon'
import LengthHelper from '@/components/shared/LengthHelper.vue'
import CheckState from '@/components/shared/CheckState.vue'
import NumberFieldFactor from '@/components/shared/NumberFieldFactor.vue'
import QtyField from '@/components/shared/QtyField.vue'
import MonthPicker from '@/components/shared/MonthPicker.vue'
import PreviewDetail from '@/components/shared/PreviewDetail.vue'
import SearchDrawer from '@/components/shared/SearchDrawer.vue'
import SelectFromList from '@/components/shared/SelectFromList.vue'
import TimePicker from '@/components/shared/TimePicker.vue' 
import IcoBadgeBtn from '@/components/shared/IcoBadgeBtn.vue'



import Section from '@/components/carte/Section.vue'
import ProduitSimple from '@/components/carte/ProduitSimple.vue'
import ProduitMultiples from '@/components/carte/ProduitMultiples.vue'
import ProduitMultiplesQuantifiable from '@/components/carte/ProduitMultiplesQuantifiable.vue'
import ProduitAccompagnement from '@/components/carte/ProduitAccompagnement.vue'
import ProduitParfum from '@/components/carte/ProduitParfum.vue'
import ProduitQuantfiable from '@/components/carte/ProduitQuantfiable.vue'
import ProduitMenuSimple from '@/components/carte/ProduitMenuSimple.vue'
import ProduitMenuBreakfast from '@/components/carte/ProduitMenuBreakfast.vue'
import LibelleSimple from '@/components/carte/LibelleSimple.vue'
import SubTitle from '@/components/carte/SubTitle.vue'
import Allergenes from '@/components/carte/Allergenes.vue'
import Bios from '@/components/carte/Bios.vue'
import ProduitOeuf from '@/components/carte/ProduitOeuf.vue'


import {i18n} from'./locale/vueI18n'

import  types from '@/store/all-action-types'



import Draggable from 'vuedraggable' 

Vue.config.productionTip = false

Vue.use(StoreHelper)
Vue.use(VConfirmDialog,{vuetify})
Vue.use( CKEditor )
//Vue.use(FlagIcon)

Vue.component('plat-section',Section)
Vue.component('plat-produit-simple',ProduitSimple)
Vue.component('plat-produit-multiples',ProduitMultiples)
Vue.component('plat-produit-multiples-quantifiable',ProduitMultiplesQuantifiable)
Vue.component('plat-produit-accompagnement',ProduitAccompagnement)
Vue.component('plat-produit-parfum',ProduitParfum)
Vue.component('plat-produit-quantifiable',ProduitQuantfiable)
Vue.component('plat-produit-menu-simple',ProduitMenuSimple)
Vue.component('plat-produit-menu-breakfast',ProduitMenuBreakfast)
Vue.component('plat-libelle-simple',LibelleSimple)
Vue.component('plat-sub-title',SubTitle) 
Vue.component('plat-allergenes',Allergenes) 
Vue.component('plat-bios',Bios) 
Vue.component('plat-produit-oeuf',ProduitOeuf) 


Vue.component('time-picker',TimePicker)
Vue.component('length-helper',LengthHelper)
Vue.component('check-state',CheckState)
Vue.component('draggable',Draggable)
Vue.component('number-field-factor',NumberFieldFactor)
Vue.component('qty-field',QtyField)
Vue.component('month-picker',MonthPicker)
Vue.component('preview-detail',PreviewDetail)
Vue.component('search-drawer',SearchDrawer)
Vue.component('search-drawer',SearchDrawer) 
Vue.component('select-from-list',SelectFromList)
Vue.component('ico-badge-btn',IcoBadgeBtn)


//On regarde si on est dans le cas d'un authorisation auto avec FULLTRUST_ALLOWED
const urlParams = new URLSearchParams(window.location.search);
const autolog = urlParams.get("autolog");



export const router = VueRouter(store)

//recupere la configuration avant de construire l'application
/*store.dispatch("ADM_CONFIGURATION_REQUEST").finally(()=>{
 
})*/

//on s'auto log si besoin
if((autolog?.length ?? 0) > 0) {
  store.dispatch(types.AUTH_AUTOLOG_REQUEST,autolog).finally(()=>{
    urlParams.delete("autolog")
    //@ts-ignore
    //window.location = window.location.pathname
    window.history.replaceState({}, '', `${location.pathname}`);    
    store.dispatch(types.ROOM_SERVICES_DATAS_ENSURE).finally(()=>{
      new Vue({  
        i18n,
        router,
        store,
        //@ts-ignore
        vuetify,
        render: h => h(App),
        mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
      }).$mount('#app')
    })
  })  
}
else{
  store.dispatch(types.AUTH_USER_REQUEST).finally(()=>{
    store.dispatch(types.ROOM_SERVICES_DATAS_ENSURE).finally(()=>{
      new Vue({  
        i18n,
        router,
        store,
        //@ts-ignore
        vuetify,
        render: h => h(App),
        mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
      }).$mount('#app')
    })
  }) 
}

//on charge les données de la carte avant de lancer l'application


//window.Vue = Vue

